import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home'
import TermsConditionsWebsite from '../views/terms-conditions-website'
import TermsConditions from '../views/terms-conditions'
import PrivacyPolicy from '../views/privacy-policy'
import ResetPassword from '../views/reset-password'
import NotFound from '../views/NotFound'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/terms-conditions-website',
    name: 'TermsConditionsWebsite',
    component: TermsConditionsWebsite
  },
  {
    path: '/terms-conditions',
    name: 'TermsConditions',
    component: TermsConditions
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  scrollBehavior: () => ({ x: 0, y: 0 }),
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
